import { render, staticRenderFns } from "./CeisaBarangImporKemasan.vue?vue&type=template&id=28e5e7f7&"
import script from "./CeisaBarangImporKemasan.vue?vue&type=script&lang=js&"
export * from "./CeisaBarangImporKemasan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports